var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('div',{staticClass:"title-container"},[_c('h5',{staticClass:"title",class:_vm.isTitleBlue ? 'blue' : 'black'},[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }